<template>
  <div class="claim-notes">
    <label>{{ title }}</label>
    <div class="claim-note" v-if="note || newNote">
      <claim-note-item
        :note="note || newNote"
        :title="title"
        @save="onSaveNote"
        @cancel="onCancelNote"
        placeholder="Please enter your note here..."
      />
    </div>
    <div class="claim-note-action">
      <button v-if="!note && !newNote" class="white small" @click="onAddNote">
        Add Note
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue';

import ClaimNoteItem from '@/components/ClaimNoteItem.vue';
import { IClaimNote, IClaimNoteOrReply, Nullable } from '@/types';

export default defineComponent({
  name: 'ClaimNote',
  components: {
    ClaimNoteItem,
  },
  props: {
    claimId: {
      type: Number,
      required: true,
    },
    note: {
      type: Object as PropType<Nullable<IClaimNote>>,
      required: false,
      default: null,
    },
    title: {
      type: String,
      default: 'Notes',
    },
  },
  emits: ['save'],
  setup(props, { emit }) {
    const newNote = ref<Nullable<IClaimNote>>(null);

    const onAddNote = () => {
      if (!props.claimId || !!props.note) {
        return;
      }

      newNote.value = {
        noteType: 'note',
        type: 'PUBLIC',
        text: '',
        replies: [],
        // eslint-disable-next-line @typescript-eslint/camelcase
        claim_id: props.claimId,
      };
    };

    function onCancelNote(): void {
      newNote.value = null;
    }

    function onSaveNote(updatedNote: IClaimNoteOrReply): void {
      emit('save', updatedNote);
      newNote.value = null;
    }

    return {
      newNote,
      onAddNote,
      onSaveNote,
      onCancelNote,
    };
  },
});
</script>

<style lang="scss" scoped>
.claim-note {
  border: 1px solid var(--grey-ultra-light);
  border-radius: 4px;
  padding: var(--space-2);
  margin-bottom: var(--space-2);
  height: auto;
  max-height: 1000px;
  transition: all 0.25s ease;

  &.hide {
    height: 0;
    max-height: 0;
  }

  .claim-note-header {
    font-size: var(--font-size-12);
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    margin-bottom: var(--space-2);
    color: var(--grey-ultra-dark);
  }

  .claim-note-reply-list {
    margin-left: var(--space-4);
  }

  .claim-note-action {
    display: flex;

    &.reply {
      justify-content: flex-end;
    }
  }
}
</style>
